import * as d3 from 'd3-fetch';
import * as turf from '@turf/turf';
import { EventBus } from '@/EventBus';

const locationsDataPromise = d3.csv(
    'https://docs.google.com/spreadsheets/d/e/2PACX-1vQvleSEA47Rq8jjWbL-BDqCUhC6A10yWxktoWywc9tmvnDPRH7XamzjwYy3Mhzp_VFRvVyzCWf7S_Fj/pub?gid=0&single=true&output=csv'
);
console.log(locationsDataPromise);

function csvToGeoJSON(rows) {
    return turf.featureCollection(
        rows
            .map((row) =>
                turf.point([+row.longitude, +row.latitude], {
                    ...row,
                    mainName: row.name.replace(/ \(.*/, ''),
                    altName: (row.name.match(/\((.*)\)/) || ['', ''])[1],
                })
            )
            .filter((org) => org.geometry.coordinates[0] !== 0)
    );
}

/*

Our primary goal:
1. User provides address and service category
2. We show service locations that match
3. We look up additional info from org


*/

// explode out the combinations
/*
function makeServicePointsTable(locations) {
    function categoryBooleans(categoryList) {
        return categoryList
            .split(/[^a-z]/)
            .filter(Boolean)
            .reduce(
                (obj, category) => ({ ...obj, [`category:${category}`]: true }),
                {}
            );
    }
    const servicePoints = [];
    const orgIds = locations.columns.slice(4);
    for (const location of locations) {
        for (const orgId of orgIds) {
            const categories = categoryBooleans(location[orgId]);
            const servicePoint = turf.point(
                [+location.longitude, +location.latitude],
                {
                    ...categories,
                    type: 'servicePoint',
                    locationName: location.name.trim(),
                    orgId,
                }
            );
            if (
                Object.keys(categories).length > 0 &&
                servicePoint.geometry.coordinates[0] +
                    servicePoint.geometry.coordinates[1] !==
                    0
            ) {
                servicePoints.push(servicePoint);
            }
        }
    }
    window.app.servicePoints = turf.featureCollection(servicePoints);
    EventBus.$emit('servicePoints-loaded', window.app.servicePoints);
}
*/

async function updateData(map) {
    const locationRows = await locationsDataPromise;
    console.log(locationRows);
    const locationsData = csvToGeoJSON(locationRows);
    console.log(locationsData);
    // makeServicePointsTable(locationRows);
    map.U.setData('locations', locationsData);
    EventBus.$emit('locations-loaded', locationsData);
}

export default async function init(map, { categories }) {
    const first = !map.getSource('locations');
    if (first) {
        map.U.addGeoJSON('locations');
        updateData(map);
    }
    map.U.addCircle('locations-circle', 'locations', {
        circleRadius: 2,
        circleColor: 'hsl(200,80%,50%)',
        circleStrokeColor: 'hsl(200,80%,20%)',
        circleStrokeWidth: 1,
        // visibility: 'none',
    });

    map.U.addSymbol('locations-text', 'locations', {
        // textField: ['get', 'name'],
        // textField: ['get', 'altName'],
        textField: [
            'step',
            ['zoom'],
            ['get', 'mainName'],
            8,
            [
                'format',
                ['get', 'mainName'],
                '\n',
                { 'font-scale': 1 },
                ['get', 'altName'],
                { 'font-scale': 0.8 },
            ],
        ],
        // textField: ['get', 'name'],
        textRadialOffset: 0.7,
        textSize: 12,
        textHaloColor: 'hsla(0,0%,100%,0.5)',
        textHaloWidth: 1.5,
        textVariableAnchor: [
            'top',
            'left',
            'right',
            'bottom',
            'bottom-left',
            'top-left',
            'bottom-right',
            'top-right',
        ],

        // textAllowOverlap: true,
        textFont: ['DIN Pro Regular'],
    });

    if (first) {
        // map.U.hoverPopup(/^locations/, (l) => `${l.properties.name}`);
        // map.on('click', 'locations-circle', (e) => {
        //     EventBus.$emit('location-click', e.features[0]);
        // });
    }
}
